module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('LoadingSpinner', {
    attrs: {
      "showContent": !_vm.isLoading,
      "size": 70
    }
  }, [(_vm.messageText.length) ? _c('Message', {
    attrs: {
      "textCenter": true,
      "closeBlock": true,
      "bold": true
    },
    on: {
      "close": _vm.closeMessage
    }
  }, [_vm._v(_vm._s(_vm.messageText))]) : _c('Form', {
    attrs: {
      "inner": true,
      "maxWidth": true
    }
  }, [_c('File', {
    attrs: {
      "label": "Приложите файл выполненного задания",
      "text": "Файл jpeg, png, gif, pdf, word",
      "fileName": _vm.resultForm.files.name,
      "warnings": _vm.fileWarnings,
      "error-text": "Приложите файл выполненного задания"
    },
    on: {
      "changeInput": _vm.inputFile
    }
  }), _c('Textarea', {
    attrs: {
      "label": "Или напишите ответ на задание"
    },
    model: {
      value: (_vm.resultForm.text),
      callback: function($$v) {
        _vm.$set(_vm.resultForm, "text", $$v)
      },
      expression: "resultForm.text"
    }
  }), _c('Button', {
    attrs: {
      "disabled": _vm.isDisabled
    },
    on: {
      "click": _vm.submitResultForm
    }
  }, [_vm._v("Отправить")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-199a0902","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/components/info/compopnents/block/components/resultform/ResulrForm.vue
// module id = 0dbfb03be3d56fdfd591
// module chunks = 89